export function parseNestedJsonStrings(value: unknown): unknown {
  if (typeof value === 'string') {
    try {
      const parsed = JSON.parse(value);
      if (parsed !== null && typeof parsed === 'object') {
        return parseNestedJsonStrings(parsed);
      }
    } catch {
      // Not valid JSON, return as-is
    }

    return value;
  }

  if (Array.isArray(value)) {
    return value.map(parseNestedJsonStrings);
  }

  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([k, v]) => [k, parseNestedJsonStrings(v)]),
    );
  }

  return value;
}
